export enum BookingSourceType {
  Admin = 1,
  Web = 2,
  App = 3,
  Other = 4,
  Portal = 5,
}
